"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var graphic_library_html_1 = __importDefault(require("./graphic-library.html"));
require("./graphic-library.less");
(function (module) {
    'use strict';
    module.factory('prGraphicLibraryModal', [
        '$rootScope',
        'qstrap.modal',
        '$filter',
        function ($rootScope, modal, $filter) {
            var translate = $filter('translate');
            return {
                show: function (callback) {
                    var scope = $rootScope.$new();
                    scope.setImage = function (imgId) {
                        if (_.isFunction(callback)) {
                            callback(imgId);
                        }
                    };
                    return modal({
                        show: true,
                        scope: scope,
                        className: 'pr-graphic-library',
                        title: translate('GRAPHIC_LIBRARIES'),
                        contentTemplate: graphic_library_html_1.default,
                        controller: 'GraphicLibraryController',
                        buttons: [
                            '<button class="btn btn-hover" ng-click="close()" translate>CLOSE</button>'
                        ],
                    });
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
